import { render, staticRenderFns } from "./fair-view.vue?vue&type=template&id=7807a1d2&scoped=true&"
import script from "./fair-view.vue?vue&type=script&lang=js&"
export * from "./fair-view.vue?vue&type=script&lang=js&"
import style0 from "./fair-view.vue?vue&type=style&index=0&id=7807a1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807a1d2",
  null
  
)

export default component.exports